import React, { type ReactNode } from 'react';

import { cssMap, cx } from '@atlaskit/css';
import Link from '@atlaskit/link/link';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { token } from '@atlaskit/tokens';

import { useCreditsRequestContext } from '../../provider/credits-request-context';
import { useCreditsStateContext } from '../../provider/credits-state-context';

const styles = cssMap({
	underlined: {
		textDecorationLine: 'underline',
	},
	action: {
		display: 'inline',
		backgroundColor: 'transparent',
		borderWidth: 0,
		paddingBlock: token('space.0'),
		paddingInline: token('space.0'),
		font: token('font.body'),
		color: token('color.link'),
		cursor: 'pointer',
	},
});
/** Email is an action; redirect requests remain native links. */
export const RequestCreditsAction = ({
	children,
	isUnderlined = false,
}: {
	children: ReactNode;
	isUnderlined?: boolean;
}): React.JSX.Element | null => {
	const request = useCreditsRequestContext();
	const state = useCreditsStateContext()?.bannerState;
	if (request?.isUnavailable) {
		return null;
	}
	const method = state?.requestMethod;
	if (method?.mode === 'REDIRECT_URL') {
		return (
			<Link appearance="subtle" href={method.redirectUrl} target="_blank" rel="noopener noreferrer">
				{children}
			</Link>
		);
	}
	return (
		<Pressable
			xcss={cx(styles.action, isUnderlined && styles.underlined)}
			isDisabled={!request || request.isPending}
			onClick={request?.start}
		>
			{children}
		</Pressable>
	);
};
